<template>
  <div class="lists">
    <van-list
      v-model="loading"
      :finished="finished"
      :finished-text="tips"
      @load="getList"
    >
      <div v-for="(item,index) in list" :key="index" class="list">
        <div class="card">
          <div class="sy-cell">
            <div class="name">
              记录时间：
            </div>
            <div class="right">
              {{ dateFormat(item.createTime, 'YY-MM-DD hh:mm') }}
            </div>
          </div>
          <div class="sy-cell">
            <div class="name">
              测量值：
            </div>
            <div class="right">
              {{ item.warningContent.sleepTime ? `${(item.warningContent.sleepTime/60).toFixed(1)}小时`:'' }}
              {{ item.warningContent.bs ? `${item.warningContent.bs }mmol/L`:'' }}
              {{ item.warningContent.sbp ? `${item.warningContent.sbp}/${item.warningContent.dbp}mmHg`: '' }}
              {{ item.warningContent.bo ? `${item.warningContent.bo }%`:'' }}
              {{ item.warningContent.hb ? `${item.warningContent.hb }次/分`:'' }}
            </div>
          </div>
          <div class="sy-cell">
            <div class="name">
              {{ type[item.dataType] }}分析：
            </div>
            <div class="right color">
              {{ item.warningContent.warningContent }}
            </div>
          </div>
        </div>
      <!--<div class="placetext">
        健康建议：xxxxxxxxxxxxxxxxxxxxxxxx
      </div>-->
      </div>
    </van-list>
  </div>
</template>
<script>
import { dateFormat } from '@/utils/tool'
import { fetchWarning } from '@/api/health'
export default {
  name: 'Waring',
  data() {
    return {
      type: {
        SLEEPQUALITY: '睡眠',
        BLOODPRESSURE: '血压',
        BLOODSUGAR: '血糖',
        BLOODOXYGEN: '血氧',
        HEARTBEAT: '心率'
      },
      dateFormat,
      tips: '',
      loading: false,
      finished: false,
      list: [],
      listQuery: {
        page: 1,
        row: 20
      }
    }
  },
  methods: {
    getList(date) {
      fetchWarning(this.listQuery).then(res => {
        this.loading = false
        const list = res.data.data
        list.forEach(item => {
          item.warningContent = JSON.parse(item.warningContent)
        })
        if (this.listQuery.page === 1) {
          this.list = list
        } else {
          this.list.concat(list)
        }
        this.page++
        this.finished = list.length <= 20
        this.tips = this.list.length ? '已经到底了' : '暂无数据'
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.lists {
  padding: 0 15px;
}
.list{
    height: auto;
    background:rgba(255,255,255,1);
    box-shadow:0px 1px 10px -5px rgba(0,0,0,0.3);
    border-radius:7px;
    padding: 15px;
    margin:10px auto 0;
.card{
    background:rgba(255,247,231,1);
    border-radius:2px;
    border:1px dashed rgba(226,174,71,1);
    padding:10px;
}
.sy-cell {
  line-height: 2;
}
.name{
    width:70px;
    color:#666666;
    text-align: right;
    line-height: 14px;
    margin-right:8px;
}
.right{
  font-size:13px;
  font-family:PingFangSC-Regular;
  font-weight:400;
  color:rgba(51,51,51,1);
}
.color{
  color:#D30404;
  font-weight: 400;
  font-size: 14px;
}
}
.placetext{
  height:auto;
  font-size:14px;
  font-family:PingFangSC-Regular;
  font-weight:400;
  color:rgba(102,102,102,1);
  line-height:20px;
}
</style>
